import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

export interface ISidebarAction {
  minimize?: boolean | 'toggle';
}

@Injectable({
  providedIn: 'root',
})
export class AppSidebarService {
  private events = new BehaviorSubject<ISidebarAction>({});
  events$ = this.events.asObservable();

  private sidebarOpenKey = 'sidebarOpen';
  private sidebarStatusSubject: Subject<boolean> = new Subject<boolean>();

  sidebarStatus$ = this.sidebarStatusSubject.asObservable();

  constructor() {
    if (localStorage.getItem(this.sidebarOpenKey) === null) {
      this.setSidebarOpen(true);
    } else {
      this.sidebarStatusSubject.next(this.isSidebarOpen());
    }
  }

  toggle(action: ISidebarAction) {
    this.events.next(action);
  }

  isSidebarOpen(): boolean {
    return localStorage.getItem(this.sidebarOpenKey) === 'true';
  }

  setSidebarOpen(value: boolean): void {
    localStorage.setItem(this.sidebarOpenKey, String(value));
    this.sidebarStatusSubject.next(value);
  }
}
